module.exports = __webpack_public_path__ + "img/24-.dbfad5b.png";